// panelController.js
import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useEffect,
} from "react";
import { useLocation } from "react-router";

const PanelContext = createContext();

export const PanelProvider = ({ children }) => {
  const [panel, setPanel] = useState(null);
  const location = useLocation();

  useEffect(() => {
    setPanel(null);
  }, [location.pathname]);

  const openPanel = useCallback((props) => {
    setPanel(props);
  }, []);

  const closePanel = useCallback(() => {
    setPanel((prev) => (prev ? { ...prev, closing: true } : null));
  }, []);

  const removePanel = useCallback(() => {
    setPanel(null);
  }, []);

  return (
    <PanelContext.Provider
      value={{ panel, openPanel, closePanel, removePanel }}>
      {children}
    </PanelContext.Provider>
  );
};

export const usePanel = () => {
  const ctx = useContext(PanelContext);
  if (!ctx) throw new Error("usePanel must be used within PanelProvider");
  return ctx;
};
